import type { Page } from '../../types';

const talentCareerQ2: Page[] = [
  {
    pageType: 'question',
    title: 'Reporting Manager Mid-Year Assessment of Talent',
    name: 'talent-career-q2',
    description:
      'Alongside Performance, individuals and line managers should regularly discuss talent and development, and agree a 9 Box Grid position.<br><br>',
    questions: [
      {
        questionType: 'select',
        title: 'How long have you been at your current substantive grade',
        name: 'talent-career-how-long-current-grade-q2',
        hintOption: 'Select an option',
        options: [
          '0 - 1 Year',
          '1 - 2 Years',
          '2 - 3 Years',
          '3 - 5 Years',
          '5 - 10 Years',
          '10+ Years',
        ],
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textarea',
        title:
          'Please list any development activity undertaken over the past 12 months to support your current role or future roles, including on-the-job learning, procured training, and schemes/programmes which you have participated in.',
        name: 'talent-career-development-activity-q2',
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default talentCareerQ2;
